import { Box } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  ArrayField,
  Button,
  Datagrid,
  NumberField,
  ReferenceField,
  TextField,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { settings } from "app";
import AddSeatDialog from "./AddSeatDialog";
import ReorderSeatsDialog from "./ReorderSeatsDialog";

const SEATS_EDITABLE_STATUSES = [1, 3, 4];

const DeleteSeatButton = ({ candidacyId }) => {
  const seat = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  if (!seat) return null;

  const handleDelete = async () => {
    await dataProvider.customRequest(
      doctoralRequests.removeCandidacySeat(candidacyId, seat.doctoralSeatId),
      null,
      "DELETE",
    );
    notify("Мястото е премахнато", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      titleContent="Премахване на място"
      saveTitle="Изтрий"
      onConfirm={handleDelete}
      triggerButton={
        <Button
          label="Изтрий"
          color="error"
          startIcon={<DeleteIcon />}
        />
      }
      message="Сигурни ли сте, че искате да премахнете това място?"
    />
  );
};

const SeatsSection = () => {
  const candidacy = useRecordContext();
  if (!candidacy) return null;

  const editable = SEATS_EDITABLE_STATUSES.includes(candidacy.status);

  return (
    <>
      <ArrayField source="seats">
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.secondaryDatagrid}
        >
          <TextField
            source="doctoralProgramNameBg"
            label="Докторантска програма"
          />
          <NumberField
            source="priority"
            label="Желание"
          />
          <ReferenceField
            label="Тип на обучение"
            source="studyTypeId"
            reference={doctoralRequests.getDoctoralStudyTypesSelect()}
            link={false}
            sortable={false}
          >
            <TextField source="name" />
          </ReferenceField>
          {editable && (
            <DeleteSeatButton
              candidacyId={candidacy.id}
              label=""
            />
          )}
        </Datagrid>
      </ArrayField>

      {editable && (
        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          <ReorderSeatsDialog />
          <AddSeatDialog />
        </Box>
      )}
    </>
  );
};

export default SeatsSection;
